import { ELogger } from '@alk/core';

/**
 * Parse string or number to ELogger enum
 * cause TypeScript present number based enum like:
 * { [string]: number;
 * [number]: string; }
 * but literally work only with number
 * this function have check parsing type
 * @param defaultLevel fallback value
 */
export const parseLogLevel = (defaultLevel: ELogger) => (value: string | number): ELogger => {

    const parsedLogLevel = ELogger[ value ] ?? defaultLevel;

    if (typeof parsedLogLevel === 'string'){
        return (ELogger)[ parsedLogLevel ];
    }

    return parsedLogLevel;
};
